import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import es from "./locales/es.json";
import en from "./locales/en.json";
import pt from "./locales/pt.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";
import zh from "./locales/zh.json";

const getUserLangKey = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    return user?.id || user?.email ? `lang:${user.id || user.email}` : "lang";
  } catch {
    return "lang";
  }
};

const savedLang = localStorage.getItem(getUserLangKey()) || localStorage.getItem("lang");
const defaultLang = (navigator.language || "en").split("-")[0];

i18n.use(initReactI18next).init({
  resources: {
    es: { translation: es },
    en: { translation: en },
    pt: { translation: pt },
    fr: { translation: fr },
    de: { translation: de },
    zh: { translation: zh },
  },
  lng: savedLang || defaultLang,
  fallbackLng: {
    pt: ["es", "en"],
    fr: ["es", "en"],
    de: ["es", "en"],
    zh: ["es", "en"],
    default: ["en"],
  },
  supportedLngs: ["es", "en", "pt", "fr", "de", "zh"],
  nonExplicitSupportedLngs: true,
  interpolation: { escapeValue: false },
  returnNull: false,
});

export const languageStorageKey = getUserLangKey;

export default i18n;
